var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.organization.name)?_c('div',{class:_vm.css('')},[_c('MolDropdown',{attrs:{"label":_vm.organization.name,"items":_vm.organizations,"on-change":_vm.selectItem}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }